"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetTypeChip = void 0;
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const useSelf_1 = __importDefault(require("@opsbase/react-ctrl-self/useSelf"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const react_1 = __importDefault(require("react"));
const Chip_1 = __importDefault(require("../Chip"));
function AssetTypeChip(props) {
    const { assetType, pdf = false } = props;
    const self = (0, useSelf_1.default)();
    if (!assetType)
        return null;
    let type = self.settings.assetTypes.find(it => it.key === assetType);
    if (!type)
        type = self.settings.assetTypes.find(it => it.key === 'unspecified');
    if (pdf) {
        return react_1.default.createElement(Text_1.default, null, type.title);
    }
    return react_1.default.createElement(Chip_1.default, { small: true, color: lib_palette_1.default.BorderGrey, label: type.title });
}
exports.AssetTypeChip = AssetTypeChip;
exports.default = AssetTypeChip;
